import { useMemo } from 'react';
import { Typography } from '@ywwwtseng/react-kit';
import { type FormElement } from './types';

export function FormLabel({ element }: { element: FormElement }) {
  const label = useMemo(() => {
    if ('label' in element) {
      return element.label ?? '';
    }

    return null;
  }, [element]);

  if (!label) {
    return null;
  }

  return (
    <Typography size="2" noWrap color="rgba(255,255,255,0.54)">
      {label}
    </Typography>
  );
}
